import { render, staticRenderFns } from "./AccountReferral.vue?vue&type=template&id=482911d3"
import script from "./AccountReferral.vue?vue&type=script&lang=js"
export * from "./AccountReferral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports